import React, { useEffect, useState } from 'react';
import { Modal, Box, Typography, IconButton, Grow } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useModalStore } from 'src/store/useModalStore';

const CustomModal: React.FC = () => {
  const { isOpen, title, subtitle, imageUrl, content, closeModal } = useModalStore();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setShowModal(true);
    } else {
      const timer = setTimeout(() => setShowModal(false), 500);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const modalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%', // Más ancho en móviles
    maxWidth: '600px', // Ancho máximo en pantallas grandes
    maxHeight: '90%', // Altura máxima para evitar que el modal sea demasiado alto
    bgcolor: '#00171F',
    boxShadow: 24,
    p: 4,
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    overflowY: 'auto', // Permite el desplazamiento si el contenido es demasiado largo
  };

  const imageContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: '16px',
  };

  const imageStyle = {
    width: '80%',
    height: 'auto',
    maxHeight: '200px', // Limita la altura de la imagen
  };

  const titleStyle = {
    marginBottom: '16px',
    textAlign: 'center' as 'center',
    background: 'linear-gradient(0deg, rgba(0,168,232,1) 0%, rgba(253,253,253,1) 73%)',
    WebkitBackgroundClip: 'text',
    color: 'transparent',
    fontSize: '2rem', // Tamaño base
    '@media (max-width: 600px)': {
      fontSize: '1.5rem', // Tamaño para pantallas pequeñas
    },
  };

  const subtitleStyle = {
    marginTop: '16px',
    marginBottom: '16px',
    textAlign: 'center' as 'center',
    fontWeight: 'bold',
    color: 'white',
    fontSize: '1.2rem', // Tamaño base
    '@media (max-width: 600px)': {
      fontSize: '1rem', // Tamaño para pantallas pequeñas
    },
  };

  const contentStyle = {
    maxHeight: '200px', // Altura máxima del contenido
    overflowY: 'auto', // Permite el desplazamiento si el contenido es demasiado largo
    textAlign: 'justify',
    padding: '8px',
    width: '100%',
    color: 'white',
    fontSize: '1rem', // Tamaño base
    '@media (max-width: 600px)': {
      fontSize: '0.875rem', // Tamaño para pantallas pequeñas
    },
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    color: 'white',
  };

  return (
    <Modal open={isOpen} onClose={closeModal}>
      <Box sx={modalStyle}>
        <IconButton sx={closeButtonStyle} onClick={closeModal}>
          <CloseIcon />
        </IconButton>
        <Grow in={showModal} timeout={1500}>
          <Box sx={{ width: '100%' }}>
            <Typography variant="h4" component="h4" sx={titleStyle}>
              {title}
            </Typography>
            <Box sx={imageContainerStyle}>
              <img src={imageUrl} alt="Modal content" style={imageStyle} />
            </Box>
            <Typography variant="subtitle1" component="h4" sx={subtitleStyle}>
              {subtitle}
            </Typography>
            <Typography variant="body1" sx={contentStyle}>
              {content}
            </Typography>
          </Box>
        </Grow>
      </Box>
    </Modal>
  );
};

export default CustomModal;